export default __webpack_public_path__ + "static/media/parkplatz.d5341a42.svg";